module.exports = __webpack_public_path__ + "imgs/instagram-color.787b1447c6450bcdbb2fdcba9c894a7f.svg";